import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	LogosModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {useRouter} from "next/router"
import React from "react"
import Marquee from "react-fast-marquee"

import styles from "./LogoSlider.module.scss"

type Props = {
	data: LogosModuleType[]
	content: AdvancedSideAssetModuleType
}

const LogoSlider = (props: Props) => {
	const {locale} = useLocale()
	const router = useRouter()
	/*
	Filter case for Swedish language becaseu CMS show Swedish language as "sv-SE"
	But website takes only "se" as Swedish
	Potentially in the future for Norway case as well, perhaps creating a helper function

	Same case for HomecustomersSection.tsx
	*/
	const isCurrentLocaleSwedish = (router.locale || locale) === "se"

	const logosFiltered = isCurrentLocaleSwedish
		? props.data.filter((logo) => logo.lang === "se")
		: props.data.filter((logo) => logo.lang === locale)

	return (
		<section>
			<Separator size={128}>
				<ContainerWrapper>
					<Typography
						className={styles.title}
						content={props.content.sectionTitle}
						variant={Variant.SectionTitle}
					/>
					<Separator />
				</ContainerWrapper>
				<Marquee className={styles.logosBox} speed={100} pauseOnHover>
					{logosFiltered.map(
						(element: LogosModuleType, index: number) => {
							return (
								<NewResponsiveImage
									key={index}
									imageClassName={styles.image}
									withoutContainer
									{...element.logo}
									alt={element.title}
								/>
							)
						},
					)}
				</Marquee>
			</Separator>
		</section>
	)
}

export default LogoSlider
